import packageJson from '../../package.json' with { type: 'json' };

/** Application version, the same value as `@unibyte/admin` in package.json. */
export const APP_VERSION: string = packageJson.version;
